module.exports = ".actions-col{width:120px;text-align:center}"